export default __webpack_public_path__ + "static/media/logolight.c1e5cf57.png";